import type { Me } from "../types";

/**
 * Аккаунт: только кто вошёл. Смены пароля и управления пользователями на сайте нет (решение владельца 30.10.2026:
 * под общим входом этим мог бы распоряжаться любой) — учётки и пароли задаются на сервере, deploy/users.sh.
 */
export function AccountPage({ me }: { me: Me }) {
  return (
    <main className="page account">
      <h1>Аккаунт</h1>
      <p className="muted">
        Вы вошли как <b>{me.username}</b>.
      </p>
      {me.mustChangePassword && (
        <div className="notice notice-warn">
          У этой учётной записи временный пароль, поэтому остальные разделы закрыты. Попросите владельца сайта задать
          постоянный пароль.
        </div>
      )}
    </main>
  );
}
